var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_82",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1001 83.3001L82.1001 60.8001L47.1001 38.3001V83.3001ZM59.6001 110.8C52.6834 110.8 46.1834 109.487 40.1001 106.86C34.0168 104.237 28.7251 100.675 24.2251 96.1751C19.7251 91.6751 16.1634 86.3834 13.5401 80.3001C10.9134 74.2168 9.6001 67.7168 9.6001 60.8001C9.6001 53.8834 10.9134 47.3834 13.5401 41.3001C16.1634 35.2168 19.7251 29.9251 24.2251 25.4251C28.7251 20.9251 34.0168 17.3618 40.1001 14.7351C46.1834 12.1118 52.6834 10.8001 59.6001 10.8001C66.5168 10.8001 73.0168 12.1118 79.1001 14.7351C85.1834 17.3618 90.4751 20.9251 94.9751 25.4251C99.4751 29.9251 103.037 35.2168 105.66 41.3001C108.287 47.3834 109.6 53.8834 109.6 60.8001C109.6 67.7168 108.287 74.2168 105.66 80.3001C103.037 86.3834 99.4751 91.6751 94.9751 96.1751C90.4751 100.675 85.1834 104.237 79.1001 106.86C73.0168 109.487 66.5168 110.8 59.6001 110.8Z",
    fill: "#E6E4DD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play-video.aae4fd44f4d959c3a0596bf673773945.svg";
export { ForwardRef as ReactComponent };